import { isPrerenderOrSnap } from "./isBotOrPrerender";

const SESSION_KEY = "detectedCountryCode";
const GEO_TIMEOUT_MS = 3000;

/**
 * Detect visitor country ISO-2 code once per session.
 * Order: sessionStorage → ipapi.co → navigator.language region → null
 * Skipped entirely during react-snap prerender (no network).
 */
export async function detectCountryCode() {
  if (isPrerenderOrSnap()) return null;

  try {
    const cached = sessionStorage.getItem(SESSION_KEY);
    if (cached) return cached === "null" ? null : cached;
  } catch {
    /* ignore */
  }

  let country = await fetchCountryFromIpapi();
  if (!country) country = countryFromNavigator();

  try {
    sessionStorage.setItem(SESSION_KEY, country || "null");
  } catch {
    /* ignore */
  }
  return country;
}

async function fetchCountryFromIpapi() {
  if (isPrerenderOrSnap()) return null;

  const controller = typeof AbortController !== "undefined" ? new AbortController() : null;
  const timer = controller
    ? setTimeout(() => controller.abort(), GEO_TIMEOUT_MS)
    : null;
  try {
    const res = await fetch("https://ipapi.co/json/", {
      signal: controller?.signal,
    });
    if (!res.ok) return null;
    const data = await res.json();
    const code = String(data?.country_code || data?.country || "").toUpperCase();
    return code.length === 2 ? code : null;
  } catch {
    return null;
  } finally {
    if (timer) clearTimeout(timer);
  }
}

function countryFromNavigator() {
  try {
    const lang = navigator.language || (navigator.languages && navigator.languages[0]) || "";
    const match = String(lang).match(/-([A-Za-z]{2})\b/);
    return match ? match[1].toUpperCase() : null;
  } catch {
    return null;
  }
}
